import React from 'react'
import { FormDisplayErrors, FormButton, FormButtonContent } from '@myxplor/forms'
import { DownloadIcon } from '@myxplor/icons'
import { Loading } from '@myxplor/ui'

const DownloadButton = ({ loading, errors = {}, onClick, children }) => (
  <div className="download--wrapper">
    {
      loading ?
        <Loading>Downloading</Loading> :
        <FormButton
          onClick={onClick}
          right
        >
          <DownloadIcon left />
          <FormButtonContent>{children}</FormButtonContent>
          <FormDisplayErrors errors={errors.summary} loading={false} />
        </FormButton>
    }
  </div>
)

export default DownloadButton



// WEBPACK FOOTER //
// ./src/ui/download-button/index.jsx